var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-content pl-2 pr-2" },
    [
      _vm._l(_vm.dateRanges, function (dateRange, index) {
        return _c(
          "div",
          { key: index },
          [
            _c("ies-hotel-batch-loader-date-range", {
              attrs: { index: index, dateRange: dateRange },
              on: {
                "add-date-range": _vm.addDateRange,
                "remove-date-range": _vm.removeDateRange,
                "update-date-range": _vm.updateDateRange,
              },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("ies-hotel-batch-loader-weekday-controls", {
        attrs: { selectedDays: _vm.selectedDays },
        on: { "toggle-day": _vm.toggleDay },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }